import React from "react";
import CaseStudyHeading from "../CaseStudiesHeading";
import CaseStudyProfile from "../CaseStudiesProfile";
// Sections
import Expenses from "./Expenses";
import Dumpty from "./Dumpty";
import DesignSprint from "./DesignSprint";
import Storytelling from "./Storytelling";
import UserResearch from "./UserResearch";

const ProductDesign = () => {
  return (
    <React.Fragment>
      <CaseStudyHeading title="Product Design" />
      <CaseStudyProfile>
        <p>
          As a Product Designer, I focus on solving real customer problems while meeting business objectives. I apply UX
          research, design thinking, and iterative processes to understand user behaviours, validate hypotheses, and
          guide informed design decisions. Techniques like user discovery, user testing, and storytelling help surface
          insights that directly shape product direction.
        </p>
        <p>
          Working in agile environments has allowed me to collaborate early and often with cross-functional teams,
          generating ideas, iterating quickly, and reducing wasted effort. This section highlights my work across
          discovery, testing, and design sprints, showing how research and insights were translated into actionable
          outcomes that informed both strategy and design.
        </p>
      </CaseStudyProfile>

      <Dumpty />
      <Expenses />
      {DesignSprint}
      {UserResearch}
      {Storytelling}
    </React.Fragment>
  );
};

export default ProductDesign;
